import { render, staticRenderFns } from "./director_change_sync.vue?vue&type=template&id=4d4ac610&"
import script from "./director_change_sync.vue?vue&type=script&lang=js&"
export * from "./director_change_sync.vue?vue&type=script&lang=js&"
import style0 from "./director_change_sync.vue?vue&type=style&index=0&id=4d4ac610&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports